import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PartnerDemoPages.css';

const DEMO_PROFILE = {
  companyName: 'Gulf Payment Solutions',
  contactName: 'Demo Partner',
  email: 'demo@comply.now',
  phone: '+974 XXX XXXX',
  type: 'Payment processor',
  country: 'Qatar',
};

export default function DemoPartnerProfile() {
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState(DEMO_PROFILE);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSaved(true);
  };

  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Partner profile</span>
      </nav>
      <header className="page-header">
       
        <p className="page-subtitle mb-0">
          Update your company and contact information. This is visible to requesting institutions.
        </p>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Company information</div>
        <div className="card-body-partner">
          {saved ? (
            <p className="text-success mb-0" style={{ color: '#0d5c3a' }}>Profile saved successfully.</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label-partner d-block">Company name</label>
                <input
                  type="text"
                  className="form-control form-control-partner w-100"
                  value={form.companyName}
                  onChange={(e) => setForm({ ...form, companyName: e.target.value })}
                  placeholder="Company name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label-partner d-block">Contact name</label>
                <input
                  type="text"
                  className="form-control form-control-partner w-100"
                  value={form.contactName}
                  onChange={(e) => setForm({ ...form, contactName: e.target.value })}
                  placeholder="Contact name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label-partner d-block">Email</label>
                <input
                  type="email"
                  className="form-control form-control-partner w-100"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="Email"
                />
              </div>
              <div className="mb-3">
                <label className="form-label-partner d-block">Phone</label>
                <input
                  type="text"
                  className="form-control form-control-partner w-100"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  placeholder="Phone"
                />
              </div>
              <div className="mb-3">
                <label className="form-label-partner d-block">Partner type</label>
                <select
                  className="form-control form-control-partner w-100"
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                >
                  <option>Payment processor</option>
                  <option>Cloud provider</option>
                  <option>Auditor</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label-partner d-block">Country</label>
                <input
                  type="text"
                  className="form-control form-control-partner w-100"
                  value={form.country}
                  onChange={(e) => setForm({ ...form, country: e.target.value })}
                  placeholder="Country"
                />
              </div>
              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-partner-primary">Save changes</button>
                <Link to="/" className="btn btn-partner-outline">Cancel</Link>
              </div>
            </form>
          )}
        </div>
      </div>
      <div className="mt-3">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
